/**
* Fetch game offer
*
* @param {String} lang
* @param {String} game
*/
function fetchOffer(lang, game) {
  const headers = {
    'Content-Type': 'application/json',
    'HTTP-X-NAB-TOKEN': 'sportradarToken',
    'HTTP-X-SEVEN-COMPANY-UUID': window.sevenConfig.company.uuid,
    'HTTP-X-NAB-COMPANY-UUID': window.sevenConfig.company.uuid,
    'HTTP-SEVEN-LOCALE': lang || window.sevenConfig.company.language,
  };
  const offerApi = `${window.sevenConfig.integrationsApiLocation.productApi.url}${process.env.VUE_APP_OFFER_URL}${game}?channel=retail`;
  return axios.get(offerApi, { headers });
}

/**
* Get results offer
*
* @param {Object} data
*/
function getResults(data) {
  const resultsApi = `${window.sevenConfig.integrationsApiLocation.productApi.url}${process.env.VUE_APP_RESULTS_URL}${data.gameId}?startDate=${data.timeFrom}&offset=${data.offset}&eventType=matches&language=${window.sevenConfig.company.language}`;
  const headers = {
    'http-x-nab-token': 'inspiredToken',
    'http-x-seven-company-uuid': window.sevenConfig.company.uuid,
    'http-x-nab-company-uuid': window.sevenConfig.company.uuid,
    'http-seven-locale': window.sevenConfig.company.language,
  };
  return axios.get(resultsApi, { headers });
}

/**
* Get game offer for print
*
* @param {Object} data
*/
function getOfferForPrint(data) {
  const resultsApi = `${window.sevenConfig.integrationsApiLocation.productApi.url}${process.env.VUE_APP_PRINTOFFER_URL}${data.gameId}`;
  const headers = {
    'http-x-nab-token': 'inspiredToken',
    'http-x-seven-company-uuid': window.sevenConfig.company.uuid,
    'http-x-nab-company-uuid': window.sevenConfig.company.uuid,
    'http-seven-locale': window.sevenConfig.company.language,
  };
  return axios.get(resultsApi, { headers });
}
export default {
  fetchOffer,
  getResults,
  getOfferForPrint,
};
